import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../../store/applicationState';
import { GetPrivateChats, SendPrivateMessage, PrivateChatActions, ClosePrivateChat } from '../../../store/privateChat/actions';
import { InfoClientType } from '../../../store/users/types';
import { TPrivateMessage } from '../../../store/privateChat/types';

export const usePrivateChat = () => {
  const [messages, setMessages] = React.useState<TPrivateMessage[] | null | undefined>(null);
  const [usersInfo, setUsersInfo] = React.useState<InfoClientType[] | null>(null);

  const { Sockets, Users, PrivateChat } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (Sockets.room) {
      dispatch(
        GetPrivateChats.request({
          data: {
            event_id: Sockets.room.event_id,
            roomId: Sockets.room.absnum,
          },
        })
      );
    }
  }, [dispatch, Sockets.room]);

  React.useEffect(() => {
    if (Array.isArray(PrivateChat.privateChats) && PrivateChat.currentUserId2) {
      setMessages(
        PrivateChat.privateChats.find((chat) => chat.userId1 === PrivateChat.currentUserId2 || chat.userId2 === PrivateChat.currentUserId2)?.messages
      );
    }
  }, [PrivateChat.privateChats, PrivateChat.currentUserId2]);

  React.useEffect(() => {
    if (Array.isArray(PrivateChat.privateChats) && Users.user && Users.users) {
      const usersInfo = [] as InfoClientType[];
      PrivateChat.privateChats.forEach((chat) => {
        if (chat.isShow1 === 1 && chat.userId1 === Users.user?.id2) {
          usersInfo.push(chat.client);
        }
        if (chat.isShow2 === 1 && chat.userId2 === Users.user?.id2) {
          usersInfo.push(chat.client);
        }
      });
      setUsersInfo(usersInfo);
    }
  }, [PrivateChat.privateChats, Users.user, Users.users]);

  const sendMessage = React.useCallback(
    (myMessage: string) => {
      if (Sockets.room && PrivateChat.currentUserId2) {
        dispatch(
          SendPrivateMessage.request({
            data: {
              event_id: Sockets.room.event_id,
              roomId: Sockets.room.absnum,
              message: myMessage,
              userId: PrivateChat.currentUserId2,
            },
          })
        );
      }
    },
    [PrivateChat.currentUserId2, Sockets.room, dispatch]
  );

  const selectPrivateChat = React.useCallback(
    (client: InfoClientType | null) => {
      dispatch(PrivateChatActions.setCurrentUserId2(client ? client.id2 : null));
    },
    [dispatch]
  );

  const closePrivateChat = React.useCallback(
    (client: InfoClientType) => {
      if (Sockets.room && !PrivateChat.loading) {
        dispatch(
          ClosePrivateChat.request({
            data: {
              event_id: Sockets.room.event_id,
              roomId: Sockets.room.absnum,
              userId: client.id2,
            },
          })
        );
        const user = usersInfo?.find((user) => user.id2 !== client.id2);
        user && dispatch(PrivateChatActions.setCurrentUserId2(user.id2));
      }
    },
    [Sockets.room, PrivateChat.loading, usersInfo, dispatch]
  );

  return {
    messages,
    usersInfo,
    sendMessage,
    selectPrivateChat,
    closePrivateChat,
  };
};
